import { render, staticRenderFns } from "./FacebookConnector.vue?vue&type=template&id=51ecf398&scoped=true&"
import script from "./FacebookConnector.vue?vue&type=script&lang=js&"
export * from "./FacebookConnector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ecf398",
  null
  
)

export default component.exports